import { Component, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { BlockUI, NgBlockUI } from 'ng-block-ui';
import { forkJoin } from 'rxjs';
import { CaseServiceViewModel } from 'src/app/models/caseservice/case-service-view-model';
import { EditCaseServiceModel } from 'src/app/models/caseservice/edit.case-service.modal';
import { CaseServicesService } from 'src/app/services/caseservice.service';
import { CasetypeService } from 'src/app/services/casetype.service';
import { RoleService } from 'src/app/services/role.service';
import { ToasterService } from 'src/app/services/toater.service';
import { minSelectedCheckboxes } from 'src/app/validators/min-selected-checkboxes.validator';

@Component({
  selector: 'app-edit-case-services',
  templateUrl: './edit-case-services.component.html',
  styleUrls: ['./edit-case-services.component.css']
})
export class EditCaseServicesComponent implements OnInit {

  @BlockUI() blockUI: NgBlockUI;
  viewModel: CaseServiceViewModel;
  model: EditCaseServiceModel;

  constructor(
    private router: Router,
    private activeRoute: ActivatedRoute,
    private formBuilder: FormBuilder,
    private toasterService: ToasterService,
    private caseServicesservice: CaseServicesService,
    private caseTypeService: CasetypeService) {
    this.viewModel = new CaseServiceViewModel();
    this.model = new EditCaseServiceModel();
    this.activeRoute.params.subscribe(params => this.model.id = Number(params.id));
  }

  form: FormGroup;
  submitted = false;
  roles: { id: string, value: string }[] = [];

  get caseTypesToFormArray(): FormArray{
    return this.form.controls.case_types as FormArray;
  }

  ngOnInit(): void {

    this.form = this.formBuilder.group({
      name: ['', [Validators.required]],
      description: [''],
      case_types: new FormArray([], minSelectedCheckboxes())
    });
    this.loadData();
  }

  private loadData(): void {
    this.blockUI.start();
    forkJoin([
      this.caseServicesservice.get(this.model.id),
      this.caseTypeService.get()
    ]).subscribe(([
      caseServiceViewModel,
      caseTypesdata
    ]) => {
      this.viewModel = caseServiceViewModel;
      const ct: FormArray = this.caseTypesToFormArray;
      ct.clear();
      caseTypesdata.forEach((d) => {
        ct.push(
          this.formBuilder.group({
            id: [d.id],
            name: [d.name],
            isSelected: [caseServiceViewModel.caseTypeIds.includes(d.id)],
          })
        );
      });
      this.form.controls.name.setValue(this.viewModel.name);
      this.form.controls.description.setValue(this.viewModel.description);

    }, error => {
      this.toasterService.ProcessErrorResponse(error);
      this.router.navigate(['/setting/cases/services-list']);
      this.blockUI.stop();
    }, () => {
      this.blockUI.stop();
    });
  }

  onSubmit(): void {
    this.submitted = true;
    if (this.form.invalid) {
      this.toasterService.error('Please fill all the required fields!');
      return;
    }
    this.model.name = this.form.value.name;
    this.model.description = this.form.value.description;
    this.model.caseTypeIds = this.form.value.case_types.filter(x => x.isSelected).map(x => x.id);
    this.blockUI.start();
    this.caseServicesservice.put(this.model).subscribe(resposne => {
      setTimeout(() => {
        this.router.navigate(['/setting/cases/services-list']);
      }, 10);
      setTimeout(() => {
        this.toasterService.success('Case service updated successfully');
      }, 300);
      this.blockUI.stop();
    },
      error => {
        this.toasterService.ProcessErrorResponse(error);
        this.blockUI.stop();
      }
    );

  }


}
